/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.TimeClock {
    angular.module("meevo.plugins.timeClock", []);
}